/* eslint-disable better-mutation/no-mutation */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { FilterNames } from 'tradera/apps/tradera/components/discover/constants/constants';

type DiscoverViewState = {
    openModalId: string | null;
    openSubMenu: FilterNames | null;
    isWardrobeProfileOpen: boolean;
};

const initialState: DiscoverViewState = {
    openModalId: null,
    openSubMenu: null,
    isWardrobeProfileOpen: false,
};

const discoverViewSlice = createSlice({
    name: 'discoverView',
    initialState,
    reducers: {
        setOpenSubMenu: (state, action: PayloadAction<FilterNames>) => {
            state.openSubMenu = action.payload;
        },
        closeSubMenu: (state, action: PayloadAction<FilterNames>) => {
            if (state.openSubMenu === action.payload) {
                state.openSubMenu = null;
            }
        },
        openWardrobeProfile: (state) => {
            state.isWardrobeProfileOpen = true;
        },
        closeWardrobeProfile: (state) => {
            state.isWardrobeProfileOpen = false;
        },
        setOpenModalId: (state, { payload }: PayloadAction<string | null>) => {
            state.openModalId = payload;
        },
        closeAllModals: (state) => {
            state.openModalId = null;
            state.openSubMenu = null;
            state.isWardrobeProfileOpen = false;
        },
    },
});

export const {
    setOpenSubMenu,
    closeSubMenu,
    setOpenModalId,
    closeAllModals,
    openWardrobeProfile,
    closeWardrobeProfile,
} = discoverViewSlice.actions;

export default discoverViewSlice.reducer;
